<script>
export default {
  name: "WhatsappNewsletterGeneralInfos",
  props: ['record', 'templates', 'sendTypes'],
  data() {
    return {
      status: {
        draft: 'Entwurf',
        started: 'Gestartet',
        stopped: 'Gestoppt',
        sent: 'Gesendet',
      }
    }
  },
  methods: {
    getTemplateName() {
      if (this.record?.whatsapp_template_id) {
        return this.templates.find(template => template.id === this.record.whatsapp_template_id).name;
      }
    },
    getSendTypeName() {
      if (this.record?.send_type) {
        return this.sendTypes.find(sendType => sendType.value === this.record.send_type).label;
      }
    }
  }
}
</script>

<template>
  <div class="panel panel-default" v-if="record">
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">Allgemeine Informationen</span>
    </div>
    <div class="panel-body">
      <table>
        <tr>
          <td><strong>Newsletter ID: </strong></td>
          <td>{{record.id}}</td>
        </tr>
        <tr>
          <td><strong>Mandant: </strong></td>
          <td>{{record.client.name}}</td>
        </tr>
        <tr>
          <td><strong>Vorlage für Kampagne: </strong></td>
          <td>{{getTemplateName()}}</td>
        </tr>
        <tr>
          <td><strong>Interner Name: </strong></td>
          <td>{{record.name}}</td>
        </tr>
        <tr>
          <td><strong>Ersteller des Newsletters:</strong></td>
          <td>{{record.creator.name}}</td>
        </tr>
        <tr>
          <td><strong>Aussendungsart:</strong></td>
          <td>{{getSendTypeName()}}</td>
        </tr>
        <tr>
          <td><strong>Status:</strong></td>
          <td>{{status[record.status]}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style scoped>
  td {
    padding-right: 20px;
  }
</style>
